import installMentions from './Mentions';

export default function install(config) {
  return installMentions(config);
}
